<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(integration.id)" v-if="$can('integration-delete') && integration.id" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="integration.name"
                  v-model="integration.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('integrations.name')"
                  :error-messages="errors.collect('integration.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="integration.slug"
                  v-model="integration.slug"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('integrations.slug')"
                  :error-messages="errors.collect('integration.slug')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-divider></v-divider>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="integration.key"
                  v-model="integration.key"
                  :label="$t('integrations.key')"
                  :error-messages="errors.collect('integration.key')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="integration.secret"
                  v-model="integration.secret"
                  :label="$t('integrations.secret')"
                  :error-messages="errors.collect('integration.secret')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "IntegrationForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      predata: {},
      integration: {},

      dictionary: {
        attributes: {
          "integration.name": this.$t("integrations.name"),
          "integration.slug": this.$t("integrations.slug"),
          "integration.key": this.$t("integrations.key"),
          "integration.secret": this.$t("integrations.secret")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.integration, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.integration))
      this.setPageTitle()
    } else {
      this.title = this.$t("integrations.edit_integration")

      axios
        .get(this.API_URL + "integration/" + this.id)
        .then((res) => {
          this.integration = res.data.data
          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.integration))
          this.setPageTitle()
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    setPageTitle() {
      if (_.has(this.integration, "id")) {
        this.page_title = this.$t("integrations.edit_integration", {
          name: this.integration.name
        })
      } else {
        this.page_title = this.$t("integrations.new_integration")
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.integration.id) {
              // Create
              axios
                .post(this.API_URL + "integration", {
                  name: this.integration.name,
                  slug: this.integration.slug,
                  key: this.integration.key,
                  secret: this.integration.secret,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.integration = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.integration))
                      vm.setPageTitle()

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/integrations/edit/${vm.integration.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "integration", {
                  id: this.integration.id,
                  name: this.integration.name,
                  slug: this.integration.slug,
                  key: this.integration.key,
                  secret: this.integration.secret
                })
                .then((res) => {
                  vm.integration = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.integration))

                  vm.setPageTitle()
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "integration/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/integrations")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
